import React from 'react'
import { CircularProgress } from '@mui/material'

type Props = {
	show?: boolean
}

const DatatableLoader = ({ show }: Props) => {
	if (!show) {
		return null
	}
	return (
		<div className="absolute inset-0 m-auto w-full flex justify-center z-30">
			<div className="relative mt-16 z-20">
				<CircularProgress />
			</div>
		</div>
	)
}

export default DatatableLoader
